import { reduceTotalLinesOfCodeByReduceSchemaSettingsSignal } from 'services/ShopifyConnection/utils/VedaOutputToShopifyThemeEditor/@consts';
import { SettingTextArea } from '../@types/SettingTextArea';

export const getSignalReduceTotalLinesOfCode = (field: SettingTextArea) => {
  return `${reduceTotalLinesOfCodeByReduceSchemaSettingsSignal.start}_SettingTextArea+${field.id}+${field.name}_${reduceTotalLinesOfCodeByReduceSchemaSettingsSignal.end}`;
};
